import React, { Component } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './NavbarCom.css';

class NavbarCom extends Component {
  render() {
    return (
      <div className="Navbar">
        <Navbar expand="lg" variant="dark" collapseOnSelect>
          <Container>
            <Navbar.Brand as={Link} to="/home">Cyclin</Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link as={Link} to="/project">Projects</Nav.Link>
                <Nav.Link as={Link} to="/Minter">Mint NFT</Nav.Link>
                <NavDropdown title="NFT market" id="collasible-nav-dropdown" className="nav-dropdown">
                  <NavDropdown.Item as={Link} to="/Collection1">Collection 1</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/Collection2">Collection 2</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item as={Link} to="/Minter">Mint NFT</NavDropdown.Item>
                </NavDropdown>
              </Nav>
              <Nav>
                <Nav.Link as={Link} to="/team">Team</Nav.Link>
                <Nav.Link href="https://github.com/" target="_blank" rel="noopener noreferrer">Contact us</Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    );
  }
}

export default NavbarCom;
